var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeroSlider',{attrs:{"slides":_vm.slides,"heightFirst":_vm.heightFirst}})}
var staticRenderFns = []

export { render, staticRenderFns }